<footer>
	<div class="container" [style.padding-bottom.px]="hasCookie ? 0 : 130">
		<div class="footer-main d-md-flex justify-content-between mb-3 hide-for-print">
			<div class="mb-3 mb-md-0 mr-0 mr-md-3">
				<a [routerLink]="['/']" ><img src="assets/images/compass-tours-logo-white.svg" alt="logo" width="200"></a>
			</div>
			
			<div class="d-flex justify-content-between mr-3">
				<div class="mb-3 mb-md-0 mr-0 mr-md-3 mr-lg-4 flex-1">
					<ul class="main">Company
						<li><a [routerLink]="['/about-us/our-story']">Our Story</a></li>
						<!-- <li><a [routerLink]="['/about-us/in-the-news']">In the News</a></li> -->
						<li><a [routerLink]="['/about-us/security']">Security</a></li>
					</ul>
				</div>
				<div class="mb-3 mb-md-0 mr-0 mr-md-3 mr-lg-4 flex-1">
					<ul class="main">Support
						<li><a [routerLink]="['/support/how-it-works']">How it Works</a></li>
						<li><a [routerLink]="['/support/contact-us']">Contact Us</a></li>
						<li><a [routerLink]="['/support/faq']">FAQ</a></li>
					</ul>
				</div>
				<div class="mb-3 mb-md-0 mr-0 mr-md-3 mr-lg-4 flex-1">
					<ul class="main">Business
						<li><a [routerLink]="['/business/travel-advisors']">Travel Advisors</a></li>
						<li><a [routerLink]="['/business/vendors']">Vendors</a></li>

						<!-- <li><a [routerLink]="['/excursions/detail/asdf']">Excursion Detail Test</a></li> -->
						<!-- <li><a [wmRedirect]="testLink">wmRedirect: {{testLink}}</a></li>
						<li><a [wmRedirect]="testLink2">wmRedirect: {{testLink2}}</a></li> -->
					</ul>
				</div>
			</div>


			<div class="mb-3 mb-md-0 mr-0 d-flex flex-column">
				<!-- <div >
					<h5>Join the Newsletter</h5>
					<p>Stay inspired and receive special offers.</p>
					<form 
						[formGroup]="newsletterForm" 
						(ngSubmit)="onSubmit()" 
						>
						<div class="input-group mb-3">
							<input type="email" 
								class="form-control bg-blue-dark" 
								placeholder="Email Address" 
								formControlName="emailAddress"
								>
							<div class="input-group-append">
								<button class="btn btn-quaternary" type="submit" >
									<fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
								</button>
							</div>
						</div>
						<div *ngIf="attemptedSubmit && newsletterForm.controls.emailAddress.errors" class="alert alert-danger" role="alert">
							<div *ngIf="newsletterForm.controls.emailAddress.errors?.required">Email is required</div>
							<div *ngIf="newsletterForm.controls.emailAddress.errors?.email">Enter valid email address</div>
						</div>
					</form>
				</div> -->
				
				<div class="d-flex">
					<div class="mr-3 icon-social">
						<a href="https://www.facebook.com/mycompasstours" target="_blank"><fa-icon [icon]="['fab', 'facebook']"></fa-icon></a>
					</div>
					<div class="mr-4 icon-social">
						<a href="https://www.instagram.com/mycompass_tours/" target="_blank"><fa-icon [icon]="['fab', 'instagram']"></fa-icon></a>
					</div>
					<div><a href="tel:14142313236">(414) 231-3236</a><br/>
						<a href="https://www.google.com/maps/place/400+E+Wisconsin+Ave+%23230,+Milwaukee,+WI+53202/@43.0412014,-87.9065979,15z/data=!4m13!1m7!3m6!1s0x880519a7815b959f:0xf731336e5c805156!2s400+E+Wisconsin+Ave+%23230,+Milwaukee,+WI+53202!3b1!8m2!3d43.0389876!4d-87.9062415!3m4!1s0x880519a7815b959f:0xf731336e5c805156!8m2!3d43.0389876!4d-87.9062415" target="_blank">400 E. Wisconsin Avenue, Suite 230A<br/>
						Milwaukee, WI 53202</a>
					</div>
				</div>
			</div>

		</div>

		<div class="d-md-flex align-items-center legal-wrapper justify-content-center pb-3">
			<div>&copy;{{currentYear}} Compass Tours. All rights reserved.</div>
			<ul class="legal ml-md-5 mb-0 d-md-flex hide-for-print">
				<li><a [routerLink]="['/privacy']">Privacy</a></li>
				<li><a [routerLink]="['/terms-of-service']">Terms of Service</a></li>
			</ul>
		</div>

	</div>
	
</footer>
